"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Card_1 = __importStar(require("@empiriecom/module-components/Card"));
var react_1 = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var styled_components_1 = __importDefault(require("styled-components"));
var Input_1 = __importDefault(require("@empiriecom/module-components/FormControls/Input"));
var useConfig_1 = __importDefault(require("../../../../hooks/useConfig"));
var ToggleButtonGroup_1 = __importDefault(require("../../../../ToggleButtonGroup"));
var ToggleButton_1 = __importDefault(require("../../../../ToggleButtonGroup/ToggleButton"));
var EmailInput_1 = __importDefault(require("./EmailInput"));
var NewsletterSubscribeTexts = react_intl_1.defineMessages({
    firstnamePlaceholder: {
        id: 'nlForm.firstName',
    },
    lastnamePlaceholder: {
        id: 'nlForm.lastName',
    },
    confirmText: {
        id: 'nlForm.confirmText',
    },
});
var StyledCard = styled_components_1.default(Card_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 1.25rem 1.25rem 3rem 1.25rem;\n  font-size: 0.813rem;\n  text-align: left;\n  margin: auto;\n  max-width: 32rem;\n\n  &&& a {\n    margin: initial;\n    display: inline;\n    font-size: 0.813rem;\n  }\n\n  #inputFields {\n    margin-top: 1.188rem;\n    > span {\n      margin-bottom: 1.188rem;\n\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n  }\n"], ["\n  padding: 1.25rem 1.25rem 3rem 1.25rem;\n  font-size: 0.813rem;\n  text-align: left;\n  margin: auto;\n  max-width: 32rem;\n\n  &&& a {\n    margin: initial;\n    display: inline;\n    font-size: 0.813rem;\n  }\n\n  #inputFields {\n    margin-top: 1.188rem;\n    > span {\n      margin-bottom: 1.188rem;\n\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n  }\n"])));
var StyledToggleButtonGroup = styled_components_1.default(ToggleButtonGroup_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 1.75rem;\n"], ["\n  margin-bottom: 1.75rem;\n"])));
var StyledConfirmtext = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 0.75rem;\n\n  @media only screen and (min-width: ", ") {\n    font-size: 0.75rem;\n  }\n"], ["\n  margin-top: 0.75rem;\n\n  @media only screen and (min-width: ", ") {\n    font-size: 0.75rem;\n  }\n"])), function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
});
var NLForm = function (_a) {
    var _b, _c;
    var setIsFormValid = _a.setIsFormValid;
    var intl = react_intl_1.useIntl();
    var _d = react_1.useState(''), salutation = _d[0], setSalutation = _d[1];
    var handleSalutation = function (event, newSalutation) {
        setSalutation(newSalutation);
    };
    var config = useConfig_1.default();
    return (react_1.default.createElement(StyledCard, { elevationLevel: Card_1.ElevationLevel['1dp'] },
        react_1.default.createElement("form", { id: "subscribeForm", "data-testid": "nlSubscribe-form" },
            react_1.default.createElement(StyledToggleButtonGroup, { value: salutation, onChange: handleSalutation },
                react_1.default.createElement(ToggleButton_1.default, { value: "female", selected: salutation === 'female' },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlForm.salutationFemale" })),
                react_1.default.createElement(ToggleButton_1.default, { value: "male", selected: salutation === 'male' },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "nlForm.salutationMale" }))),
            react_1.default.createElement("div", { id: "inputFields" },
                react_1.default.createElement(Input_1.default, { id: "newsletterFirstName", name: "firstName", label: intl.formatMessage(NewsletterSubscribeTexts.firstnamePlaceholder) }),
                react_1.default.createElement(Input_1.default, { id: "newsletterLastName", name: "lastName", label: intl.formatMessage(NewsletterSubscribeTexts.lastnamePlaceholder) }),
                react_1.default.createElement(EmailInput_1.default, { setIsFormValid: setIsFormValid, companyId: process.env.FRAGMENT_COMPANYID })),
            react_1.default.createElement("input", { id: "newsletterSalutation", type: "hidden", name: "salutation", value: salutation })),
        react_1.default.createElement(StyledConfirmtext
        // eslint-disable-next-line react/no-danger
        , { 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: intl.formatMessage(NewsletterSubscribeTexts.confirmText),
            }, tabletMinWidth: (_c = (_b = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.tabletMinWidth })));
};
exports.default = NLForm;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Form.js.map